var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "berg-icons-adult",
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 5.2C11.836 5.2 13 4.03594 13 2.6C13 1.16406 11.836 0 10.4 0C8.96411 0 7.80005 1.16406 7.80005 2.6C7.80005 4.03594 8.96411 5.2 10.4 5.2Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.457 7.943C14.95 7.436 14.079 6.5 12.389 6.5C12.116 6.5 10.543 6.5 9.087 6.5C5.512 6.487 2.6 3.575 2.6 0H0C0 4.108 2.743 7.592 6.5 8.723V26H9.1V18.2H11.7V26H14.3V10.465L19.435 15.6L21.268 13.767L15.457 7.943Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdult);
export default __webpack_public_path__ + "static/media/adult.65fa42c706f3e8203f7327b13ce619ac.svg";
export { ForwardRef as ReactComponent };